import {useMutation, useQuery} from "@tanstack/react-query";
import {useNavigate} from "react-router-dom";
import {handleResponse, queryClient} from "./setup";
import Noti from "../../view/components/general/noti";
import {ROUTES} from "../../constants";
import {ConditionService} from "../../services/requests/condition";

const useGetConditions = (params: any, modalName?: boolean) => {
  return useQuery({
    queryKey: ["getConditions", params],
    queryFn: ({ queryKey }: any) => {
      const [_, params] = queryKey;
      return ConditionService.getConditionsList(params);
    },
    enabled: modalName ?? true
  });
}

const useGetCondition = () => {
  return useMutation({
    mutationFn: ConditionService.getCondition,
  })
}

const useAddCondition = () => {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: ConditionService.addCondition,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          Noti("success", data?.data?.msg)
          navigate(ROUTES?.CONDITION?.PATH);
        }
      })
    },
  })
}

const useDeleteCondition = ({
  onSuccess
}: {
  onSuccess: () => void
}) => {
  return useMutation({
    mutationFn: ConditionService.deleteCondition,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          console.log(data)
          Noti("success", data?.data?.msg)
          queryClient.invalidateQueries({ queryKey: ["getConditions"] })
          onSuccess();
        }
      })
    },
    onError: (error) => {
      Noti("error", error?.message)
    }
  })
}

export {
  useGetConditions,
  useGetCondition,
  useAddCondition,
  useDeleteCondition
}
